/**
 * polyfill
 * visibilitychange事件和document.hidden字段
 */

/**
 * 添加下document上的属性
 */
declare const document: Document & {
  msHidden?: boolean;
  webkitHidden?: boolean;
  mozHidden?: boolean;
};

// eslint-disable-next-line import/no-mutable-exports
let HIDDEN: string;
// eslint-disable-next-line import/no-mutable-exports
let VISIBILITY_CHANGE: string;

if (typeof document.hidden !== 'undefined') {
  HIDDEN = 'hidden';
  VISIBILITY_CHANGE = 'visibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
  HIDDEN = 'msHidden';
  VISIBILITY_CHANGE = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
  HIDDEN = 'webkitHidden';
  VISIBILITY_CHANGE = 'webkitvisibilitychange';
} else if (typeof document.mozHidden !== 'undefined') {
  HIDDEN = 'mozHidden';
  VISIBILITY_CHANGE = 'mozvisibilitychange';
}

export { HIDDEN, VISIBILITY_CHANGE };
